export const typography = {
  useNextVariants: true,
  fontFamily: [
    'Open Sans, sans-serif, Axia Black, OpenSansExtraBold, OpenSansBold, Open Sans',
  ].join(','),
  fontSize: 18,
  fontWeight: 400,
};
